<template>
  <div class="header  shadow-1 ">
    <div class="color-text text-xl  flex align-items-center	">
      <img :src="logo" height="35">
      <span class="ml-2">Minha escola</span>
    </div>
    <Menu ref="menu" id="overlay_menu" :model="items" :popup="true" />
    <div class="flex align-items-center gap-3">
      <slot name="menu"></slot>
      <Avatar icon="pi pi-user" class="mr-2 cursor-pointer" size="small" shape="circle" @click="toggle" />

    </div>
  </div>
  <Dialog v-model:visible="visible" modal header="Créditos" :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
    <div class="color-text mb-3">
      Esse app foi desenvolvido com as seguintes tecnologias: Vue, PrimeVue, PrimeFlex, Supabase e Vercel.
    </div>
    <div class="color-text mb-2"> A versão de estudante desse app foi planejada com o apoio de três estudantes de turmas
      do primeiro ano de
      2023, nas oficinas de programação que aconteceram na escola: Bernardo Breier Bernardi, Théo Engel Noronha e Luís
      Otávio Figueiredo da Silva Gomes.</div>
  </Dialog>

</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import router from '@/router';
import { useStore } from 'vuex';
import Menu from "primevue/menu";
import Avatar from "primevue/avatar"
import logo from "@/assets/logo.svg"
import Dialog from 'primevue/dialog';

import { supabase } from "@/supabase";



const visible = ref(false)
const menu = ref();
const items = ref([
  { label: 'Sair', icon: 'pi pi-sign-out', command: () => sair() }
  
]);

const user = computed(() => store.state.userSession.user)


onMounted(() => {
  if(user.value.funcao == "professor") {
    items.value.unshift({ label: 'Gerenciar assinatura', icon: 'pi pi-credit-card', command: () => gerenciarAssinatura() })
  }
})

async function gerenciarAssinatura() {

  const { data, error } = await supabase.functions.invoke(
    'billing-portal',
  )

  if (error) {
    console.error(error);
    throw error;
  }


  window.location.href = data.url;
}


const toggle = (event) => {
  menu.value.toggle(event);
};

const store = useStore();

const sair = async () => {
  console.log('saindo')
  store.commit('setLoading', true)
  store.commit('setUserSession', null);
  const { error } = await supabase.auth.signOut();
  if (error || store.state.userSession != null) {
    store.commit('setLoading', false)
    alert("Ocorreu um erro ao sair")
    return
  }
  store.dispatch('updatePaginaFazerLogin', true)
  store.commit('setLoading', false)
  router.push('/')
}

const mostrarInfo = () => {
  visible.value = true
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 4;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;
  box-sizing: border-box;
  background-color: #fff;


}
</style>